import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule, OutletModule, OutletRefModule, PageComponentModule, PageLayoutModule, PageSlotModule } from '@spartacus/storefront';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { KbMyAddressbookComponent } from './kb-my-addressbook/kb-my-addressbook.component';
import { AddressforemergencyOrdersComponent } from './addressforemergency-orders/addressforemergency-orders.component';
import { UpdateAddressComponent } from './update-address/update-address.component';
import { DeletePopup2Component } from './delete-popup2/delete-popup2.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../../kb-pagination/kb-pagination/kb-pagination.module';


@NgModule({
    declarations: [KbMyAddressbookComponent, AddressforemergencyOrdersComponent, UpdateAddressComponent, DeletePopup2Component],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MediaModule,
        MatExpansionModule,
        KbMyAccountLeftSideNavModule,
        PageLayoutModule,
        OutletModule,
        OutletRefModule,
        PageSlotModule,
        KbPaginationModule,
        PageComponentModule,
        FormsModule,
        ReactiveFormsModule,
        ConfigModule.withConfig({
            cmsComponents: {
                AccountAddressBookComponent: {
                    component: KbMyAddressbookComponent,
                    guards: [SecureGuard, AuthGuard]
                },
                MyAddressBookAddFlexComponent: {
                    component: AddressforemergencyOrdersComponent,
                    guards: [SecureGuard, AuthGuard]
                },
                MyAddressBookEditFlexComponent: {
                    component: UpdateAddressComponent,
                    guards: [SecureGuard, AuthGuard]
                }
            }
        } as CmsConfig)
    ],
})
export class KbMyAddressBookModule { }
